<template>
  <div class="container sv060">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>会員さま専用サイトのサービス利用時におけるSMS認証の導入について</HeadingOne>

    <p class="_mb-md-30 _mb-sm-20">
      第三者による不正な使用や情報変更を防ぐため、au PAY
      スマートローンではSMSを使用した追加認証を導入しております。そのため、今後安心してご利用いただくためにSMSが利用可能な携帯電話番号のご登録が必要となります。
    </p>

    <p class="_mb-md-30 _mb-sm-20">
      <span class="-bold orange margin">追加認証が必要な手続き</span><br />
      〇お借り入れ 〇お客さま情報変更
    </p>

    <p class="_mb-md-0 _mb-sm-0">
      <span class="-bold orange margin">SMS認証とは？</span><br />
      暗証番号認証後、SMS認証を合わせて行い、２つの異なる認証を行う方法です。
    </p>

    <section>
      <StepList type="sv" class="-orange">
        <HeadingTwo>SMS認証 操作方法</HeadingTwo>
        <p class="-bold _mb-md-30 _mb-sm-20">＜auIDに携帯電話番号を登録済の方＞</p>
        <StepItem
          id="section_01"
          name="section_01"
          number="1"
          title="ワンタイムパスワード送信"
          src="sv/sv060/01.png"
          src-sp="sv/sv060/01s.png"
        >
          <ListGroup class="-normal -decimal">
            <ListItem class="-normal">ワンタイムパスワードの送信先を確認</ListItem>
            <ListItem class="-normal">「ワンタイムパスワードを送信する」ボタンを押下</ListItem>
          </ListGroup>
          <ListGroup class="-note">
            <ListItem class="-note"> SMS認証を行うためには、携帯電話番号のご登録が必要となります。 </ListItem>
            <ListItem class="-note">
              au/UQ mobileの携帯電話番号のお客さまは、My auにてau IDの携帯電話番号の変更手続きができます。<br />
              <a href="https://www.au.com/my-au/" target="_blank">My au はこちら＞</a>
            </ListItem>
          </ListGroup>
        </StepItem>
        <StepItem
          id="section_02"
          name="section_02"
          number="2"
          class="-none"
          title="ワンタイムパスワードの入力"
          src="sv/sv060/02.png"
          src-sp="sv/sv060/02.png"
        >
          <ListGroup class="-normal -decimal">
            <ListItem class="-normal">SMSに届いた6桁の認証コードをワンタイムパスワードの入力欄に入力</ListItem>
            <ListItem class="-normal">「ワンタイムパスワードで認証する」ボタンを押下</ListItem>
            <ListItem class="-normal">画面に従い、ご希望の手続きを進める</ListItem>
          </ListGroup>
          <ListGroup class="-note">
            <ListItem class="-note">
              SMSに認証コードが届かない場合 ワンタイムパスワードの再送、 または登録の携帯電話番号を再度ご確認ください。
            </ListItem>
          </ListGroup>
        </StepItem>

        <p class="-bold _mb-md-30 _mb-sm-20">＜au IDに携帯電話番号が未登録の方＞</p>
        <p class="_mb-md-30 _mb-sm-20">
          SMS認証を行うためには、SMSが利用可能な携帯電話番号のご登録が必要となります。ご登録済の金融機関口座番号で認証後の画面から、携帯電話番号をご登録ください。<br />
          au IDに、au/UQ mobile以外の携帯電話番号を登録されている方が、変更される場合もこちらの手順で変更ができます。
        </p>
        <StepItem
          id="section_03"
          name="section_03"
          number="1"
          title="口座番号入力"
          src="sv/sv060/03.png"
          src-sp="sv/sv060/03s.png"
        >
          <ListGroup class="-normal -decimal">
            <ListItem class="-normal">ご登録のお引落し口座番号７桁を入力</ListItem>
            <ListItem class="-normal">「認証する」ボタンを押下</ListItem>
          </ListGroup>
          <div class="orange-block">
            <p class="orange -bold line">ゆうちょ銀行の番号変換</p>
            <p>ご登録の銀行口座がゆうちょ銀行の場合、以下のように番号を変換してご入力ください。</p>
            <p class="font14">●口座番号は桁数に関わらず、「番号」の最後の「1」をとる</p>
            <img src="@/assets/images/sv/sv060/number_exchange.svg" />
          </div>
        </StepItem>
        <StepItem
          id="section_04"
          name="section_04"
          number="2"
          title="携帯電話番号のご登録"
          src="sv/sv060/04.png"
          src-sp="sv/sv060/04s.png"
        >
          <ListGroup class="-normal -decimal">
            <ListItem class="-normal">変更する携帯電話番号を入力</ListItem>
            <ListItem class="-normal">「確認画面へ」ボタンを押下</ListItem>
          </ListGroup>
        </StepItem>
        <StepItem
          id="section_05"
          name="section_05"
          number="3"
          title="入力内容のご確認"
          src="sv/sv060/05.png"
          src-sp="sv/sv060/05s.png"
        >
          <ListGroup class="-normal -decimal">
            <ListItem class="-normal">入力した携帯電話番号を確認</ListItem>
            <ListItem class="-normal">「変更する」ボタンを押下</ListItem>
          </ListGroup>
        </StepItem>
        <StepItem
          id="section_06"
          name="section_06"
          class="-none"
          number="4"
          title="携帯電話番号の登録変更完了"
          src="sv/sv060/06.png"
          src-sp="sv/sv060/06s.png"
        >
          <ListGroup class="-normal -decimal">
            <ListItem class="-normal">完了後、トップページに戻る。</ListItem>
            <ListItem class="-normal">ご希望の手続きを選択する</ListItem>
            <ListItem class="-normal">画面に従い、ご希望の手続きを進める</ListItem>
          </ListGroup>
        </StepItem>
      </StepList>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import StepList from "@/components/steps/StepList";
import StepItem from "@/components/steps/StepItem";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { isWebView } from "@/utils/UserAgent";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Sv060",
  components: {
    ListGroup,
    ListItem,
    HeadingOne,
    HeadingTwo,
    StepList,
    StepItem,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "会員さま専用サイトのサービス利用時におけるSMS認証の導入について",
      description: "",
      keywords: "",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お借り入れについて",
          routerName: "sv046",
        },
        {
          text: "追加認証のご案内",
          active: true,
        },
      ],
      check: {
        expectation: "",
      },
    };
  },
  mounted() {
    setTimeout(this.scrolleToHash, 300);
  },
  methods: {
    scrolleToHash() {
      if (this.$route.hash.match(/^#/)) {
        let id = this.$route.hash.replace(/^#/, "");
        let element = document.getElementById(id);
        let height = window.matchMedia && window.matchMedia("(max-device-width: 767px)").matches ? -70 : -120;
        let offset = isWebView() ? -10 : height;
        this.$scrollTo(element, 400, { easing: "ease", offset: offset });
      }
    },
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.list-group {
  > .list-item {
    > .badge-icon {
      padding-left: 15px !important;
      padding-right: 15px !important;
      @include mq-up(md) {
        padding-left: 20px !important;
        padding-right: 20px !important;
        margin-left: 10px;
      }
    }
  }
}
.step-box {
  @include mq-up(md) {
    display: flex;
  }
  > .step-img {
    max-width: 100%;
    @include mq-up(md) {
      max-width: 44.5%;
    }
  }
  > .step-txt {
    max-width: 100%;
    @include mq-up(md) {
      max-width: 55.5%;
    }
  }
}
.-red {
  color: $danger;
}

.orange {
  color: $orange;

  &.margin {
    display: inline-block;
    margin-bottom: 20px;
    line-height: normal;
    @media screen and (max-width: 767px) {
      margin-bottom: 16px;
    }
  }

  &.line {
    line-height: 100%;
  }
}

.sv060 {
  :deep(.step-item) {
    &.-none {
      > .step-border {
        > .border {
          width: 0;
        }
      }
    }
  }
  :deep(.list-group) {
    &.-decimal {
      .list-item {
        list-style-type: decimal;
      }
    }
  }

  .font14 {
    font-size: 14px;
  }

  .orange-block {
    border: 1px solid $orange;
    padding: 24px;
    max-width: 433px;
    line-height: 0;
    @media screen and (max-width: 767px) {
      padding: 18px;
    }
  }
}
</style>
